import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';

import { messages } from './messages';
import { getBatchDetailsOrdersShipmentsMode } from '../../store/batches/details/batch.details.actions';
import { BulkActionDataType } from '../../enums/bulk-action-data-type';

const getFulfillmentPlanCount = (job) => get(job, 'jobData.fulfillmentPlanCount', 0);

export const ordersShipmentsModeBatchDetailsFull = {
  id: BulkActionDataType.ORDERS_SHIPMENT_MODE_BATCH_DETAILS_FULL,
  getBulkApplyMessageCount: getFulfillmentPlanCount,

  bulkApplyMessage: (count) => (
    <FormattedMessage
      {...messages.bulkApplyMessage}
      values={{
        numberOfShipments: count,
        boldCount: <b>{count}</b>,
      }}
    />
  ),

  requestFilter: (fulfillmentPlanSetIds) =>
    fulfillmentPlanSetIds.map((fulfillmentPlanSetId) => ({
      fulfillmentPlanSetId,
    })),

  startUpdateNotificationContent: (job) => {
    const numberOfShipments = getFulfillmentPlanCount(job);
    return <FormattedMessage {...messages.ordersShipmentModeBatchDetailsFull} values={{ numberOfShipments }} />;
  },

  updateSuccessNotificationContent: (job) => {
    const numberOfShipments = getFulfillmentPlanCount(job);
    return <FormattedMessage {...messages.ordersShipmentModeBatchDetailsFullSuccess} values={{ numberOfShipments }} />;
  },

  updateSuccessActions: () => [getBatchDetailsOrdersShipmentsMode()],
};
